import { Component, OnInit, OnDestroy } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { IbisProvider } from '../../providers';

@Component({
  selector: 'app-create-ibis-report',
  templateUrl: './create-ibis-report.component.html',
  styleUrls: ['./create-ibis-report.component.scss']
})
export class CreateIbisReportComponent implements OnInit, OnDestroy {

  subject: Subject<any>;
  subscription: any;
  value: any = null;

  constructor(
    public ibisProvider: IbisProvider,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService
  ) { }

  ngOnInit(): void {
    this.subscription = this.modalService.onHide.subscribe((reason: string) => {
      if (reason === 'esc') {
        this.onCancel();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  onConfirm(): void {
    this.bsModalRef.hide();
    this.subject.next(this.value);
    this.subject.complete();
  }

  onCancel(): void {
    this.bsModalRef.hide();
    this.subject.next(false);
    this.subject.complete();
  }

  onValueChanged(value: any): void {
    this.value = value ? value.VALUE : null;
  }
}
